module.exports = __webpack_public_path__ + "img/search-local.6b7e670a.svg";